import {
    BottomNavigation,
    BottomNavigationAction,
    Box,
    Button,
    styled,
} from "@material-ui/core";
import {
    ArrowBackIos as BackIcon,
    EmojiEvents as TastingIcon,
    FormatListNumbered as ResultsIcon,
    LocalDrink as BeerIcon,
    People as TastersIcon,
    PlaceOutlined as VenueIcon,
} from "@material-ui/icons";
import FullPageCircularProgress from "components/full-page-circular-progress";
import { brand } from "../../theme";

export const Container = styled(({ ...p }) =>
    <div {...p} />
)({
    minHeight: '100vh',
    background: brand.surface,
    // Fixed BottomNavigationBar is 54 + 14 = 68 px tall; add a little headroom
    // so the last row of any tab isn't clipped underneath it.
    paddingBottom: 80,
});

export const BackButton = styled((p) =>
    <Button color="inherit" {...p} >
        <BackIcon />
        <span>Events</span>
    </Button>
)(({ theme }) => ({
    marginRight: theme.spacing(0.5),
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: 0.6,
    textTransform: 'uppercase',
    minWidth: 'auto',
    '& svg': {
        fontSize: 14,
        marginBottom: 2,
        marginRight: 2,
    },
}));

export const EditButton = styled(({ ...p }: any) =>
    <Button color="inherit" {...p} >
        Edit
    </Button>
)(({ theme }) => ({
    marginLeft: theme.spacing(0.5),
    fontSize: 12,
    fontWeight: 800,
    letterSpacing: 0.6,
    textTransform: 'uppercase',
    minWidth: 'auto',
}));

export const CircularProgress = FullPageCircularProgress;


export const BottomNavigationBar = styled(({ className, ...p }: any) =>
    <Box className={className}>
        <BottomNavigation
            showLabels
            {...p}
        />
    </Box>
)({
    width: '100%',
    position: 'fixed',
    bottom: 0,
    zIndex: 1,
    background: brand.white,
    borderTop: `1px solid ${brand.sep}`,
    '& .MuiBottomNavigation-root': {
        background: brand.white,
        height: 'calc(54px + 14px)',
        paddingBottom: '14px',
    },
    '& .MuiBottomNavigationAction-root': {
        color: brand.textDis,
        minWidth: 0,
    },
    '& .MuiBottomNavigationAction-root.Mui-selected': {
        color: brand.amber,
        '& .MuiBottomNavigationAction-label': {
            fontWeight: 700,
        },
    },
    '& .MuiBottomNavigationAction-label': {
        fontSize: 10,
        marginTop: 2,
        letterSpacing: 0.2,
    },
    '& .MuiBottomNavigationAction-label.Mui-selected': {
        fontSize: 10,
    },
});

export const TastingBarItem = styled(({ ...p }) =>
    <BottomNavigationAction
        label="Tasting"
        icon={
            <TastingIcon />
        }
        {...p}
    />
)({

});

export const ResultsBarItem = styled(({ ...p }) =>
    <BottomNavigationAction
        label="Results"
        icon={
            <ResultsIcon />
        }
        {...p}
    />
)({

});

export const BeersBarItem = styled(({ ...p }) =>
    <BottomNavigationAction
        label="Beers"
        icon={
            <BeerIcon />
        }
        {...p}
    />
)({

});


export const TastersBarItem = styled(({ ...p }) =>
    <BottomNavigationAction
        label="Tasters"
        icon={
            <TastersIcon />
        }
        {...p}
    />
)({

});

export const VenueBarItem = styled(({ ...p }) =>
    <BottomNavigationAction
        label="Venue"
        icon={
            <VenueIcon />
        }
        {...p}
    />
)({

});
